//* 채널톡 SDK는 boot 콜백 인자를 `Error | null`로 선언하지만(dist/index.d.ts) 부팅 실패 시 실제로는
//* `{ errors, language, status, type }` 평문 객체를 넘긴다. 평문 객체를 captureException에 그대로 전달하면
//* Sentry가 그룹 제목을 미니파이된 감싼 함수명으로 잡아 판독·집계가 불가해진다 (WELLO-8CD).
export const toChannelBootError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  }

  const status =
    typeof error === 'object' && error !== null && 'status' in error
      ? error.status
      : undefined;

  return new Error(
    typeof status === 'number'
      ? `ChannelIO boot failed (status: ${status})`
      : 'ChannelIO boot failed',
  );
};
